import { Router, NavigationEnd } from '@angular/router';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';
import { Subject, Observable, Subscription } from 'rxjs';
import { Message } from 'src/app/models/message';
import * as moment from 'moment';

@Injectable({
	providedIn: 'root'
})
export class SiteService {

	private subject = new Subject<Message>();

	constructor(private router: Router) {

	}

	public error(arg: any): void {

		console.log("error", arg);
		if (!arg){
			return;
		}

		let type = arg.error.type;
		let msg = arg.error.message;

		if (type && (type == "MessageException" || type == "OrderException" || type == "PaymentException")) {
			alert(msg);
		} else {

			if (arg && arg.error && arg.status && arg.status == 504){
				alert("일시적인 오류가 발생했습니다. 잠시후 다시 시도해주세요 (" + arg .status + ")");
			}else{
				alert("일시적인 오류가 발생했습니다. 잠시후 다시 시도해주세요");
			}
			
		}
	}



	public sendMessage(message: Message) {
		//this.subject.next({ text: message });
		this.subject.next(message);
	}

	public clearMessage() {
		this.subject.next();
	}

	public getMessage(): Observable<Message> {
		return this.subject.asObservable();
	}

	public toObject(list: any[], instance: any): any[] {

		let result = [];
		if (list == null)
			return result;

		for (let item of list) {
			let obj = new instance();
			result.push(Object.assign(obj, item));
		}
		return result;

	}




}